<template>
  <v-container fluid>
    <v-btn text @click="$router.back()">
      <v-icon left class="px-2">mdi-arrow-left</v-icon>
      {{ $t("back") }}
    </v-btn>

    <h2 class="font-weight-bold my-4">
      {{ $route.params.id ? $t("update_user") : $t("add_user") }}
    </h2>

    <v-form ref="form" v-model="valid" lazy-validation>
      <v-row dense>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="form.username"
            :label="$t('username')"
            :rules="[rules.required]"
            required
            outlined
            dense
          />
        </v-col>

        <v-col cols="12" md="6">
          <v-text-field
            v-model="form.password"
            :label="$t('password')"
            :rules="[rules.required]"
            type="password"
            required
            outlined
            dense
          />
        </v-col>

        <v-col cols="12" md="6">
          <v-text-field
            v-model="form.first_name"
            :label="$t('first_name')"
            :rules="[rules.required]"
            required
            outlined
            dense
          />
        </v-col>

        <v-col cols="12" md="6">
          <v-text-field
            v-model="form.last_name"
            :label="$t('last_name')"
            :rules="[rules.required]"
            required
            outlined
            dense
          />
        </v-col>

        <v-col cols="12">
          <v-text-field
            v-model="form.email"
            :label="$t('email')"
            :rules="[rules.email]"
            outlined
            dense
          />
        </v-col>

        <v-col cols="12">
          <v-text-field
            v-model="form.phone"
            :label="$t('phone_number')"
            outlined
            dense
          />
        </v-col>

        <v-col cols="12" md="6">
          <v-select
            v-model="form.role"
            :items="roles"
            item-text="name"
            item-value="id"
            :label="$t('role')"
            :rules="[rules.required]"
            :disabled="!!$route.params.id"
            required
            outlined
            dense
          />
        </v-col>

        <v-col cols="12" md="6">
          <v-select
            v-model="form.status"
            :items="statusOption"
            item-text="name"
            item-value="id"
            :label="$t('status')"
            outlined
            dense
          />
        </v-col>

        <v-col cols="12">
          <v-btn color="amber darken-2" :disabled="!valid" @click="submitForm">
            {{ $route.params.id ? $t("update_user") : $t("add_user") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>
<script>
import api from "../services/axios";

export default {
  data() {
    return {
      valid: false,
      roles: [],
      statusOption: [
        {
          name: 'Active',
          id: 1
        },
        {
          name: 'Inactive',
          id: 0
        }
      ],
      menu: false,

      form: {
        username: "",
        password: "",
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        address: "",
        joined: "",
        role: "",
        status: "1",
      },
      rules: {
        required: (v) => !!v || this.$t("field_required"),
        email: (v) =>
          !v ||
          /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ||
          this.$t("email_invalid"),
      },
    };
  },
  mounted() {
    this.fetchRoles();
    if (this.$route.params.id) {
      this.fetchDetails();
    }
  },
  methods: {
    async fetchDetails() {
      try {
        const res = await api.get("/employee/view/" + this.$route.params.id);
        const data = res.data.data;
        this.form.first_name = data.first_name;
        this.form.last_name = data.last_name;
        this.form.email = data.email;
        this.form.phone = data.phone;
        this.form.role = data.role;
        this.form.status = data.status;
        this.form.address = data.address;
      } catch (error) {
        console.error("Failed to load categories:", error);
      }
    },
    async fetchRoles() {
      try {
        const res = await api.get("/roles");

        this.roles = res.data.data;
      } catch (error) {
        console.error("Failed to load roles:", error);
      }
    },
    async submitForm() {
      if (!this.$refs.form.validate()) return;

      const formData = new FormData();
      formData.append("username", this.form.username);
      formData.append("password", this.form.password);
      formData.append("first_name", this.form.first_name);
      formData.append("last_name", this.form.last_name);
      if (this.form.email) formData.append("email", this.form.email);
      if (this.form.phone) formData.append("phone", this.form.phone);
      formData.append("status", this.form.status);

      try {
        const res = await api.post(
          !this.$route.params.id
            ? "employee/add"
            : "employee/update/" + this.$route.params.id,
          formData,
          {
            headers: {
              Accept: "application/json",
              "Accept-Language": "en",
            },
          }
        );
        if (!res.data.status) {
          this.$root.$emit("show-snackbar", {
            message: this.$te(res.data.locale_key) ? res.data.locale_key : res.data.message,
            color: "error",
          });
        } else {
          this.$root.$emit("show-snackbar", {
            message: this.$te(res.data.locale_key) ? res.data.locale_key : res.data.message,
            color: "success",
          });
          this.$router.back();
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
